<mat-toolbar class="toolbar">
    <mat-toolbar-row class="toolbar-row__header-top">
     <!--  <app-input-tabla></app-input-tabla>
      <img
        class="notifications"
        src="../../../assets/notificacion-aviso-activo.png"
      /> -->
      <img [routerLink]="['']" class="logout" src="../../../assets/log-out.png" (click)="removeUserStorage()"/>
    </mat-toolbar-row>
    <mat-toolbar-row class="toolbar-row__header-bottom">
      <app-titulo-header-contratista></app-titulo-header-contratista>
    </mat-toolbar-row>
  </mat-toolbar>
  
